<template>
  <div class="modal-container">
    <LsClickable
      track-id="message_received_modal-close"
      class="modal-close-x"
      @click="close"
      @mouseover="closeColor = 'gray-secondary'"
      @mouseleave="closeColor = 'primary'"
    >
      <LsIcon type="close" :color="closeColor" />
    </LsClickable>
    <div style="min-height: 200px;">
      <div>
        <header class="modal-header">
          <LsIcon size="md" type="checkfull" color="primary" />
          {{ t('messageReceived.label') }}
        </header>
        <section class="modal-body">
          <p class="block">{{ t('messageReceived.messageSubmitted', { brandName, userEmail }) }}</p>
          <p class="block">{{ t('messageReceived.doNotSubmitMultiple') }}</p>
        </section>
        <footer class="modal-footer">
          <LsButton text="ok" track-id="message_received_modal-ok" @click="close" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton, LsClickable, LsIcon } from '@/components/common';
import { getBrandName } from '@/helpers';
import { mapState } from 'vuex';

export default {
  name: 'MessageReceivedModal',
  components: {
    LsIcon,
    LsClickable,
    LsButton,
  },
  data() {
    return { closeColor: 'primary' };
  },
  computed: {
    ...mapState(['auth']),
    brandName() {
      return getBrandName();
    },
    userEmail() {
      return this.auth.user.email;
    },
  },
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>
